var map = {
	"./promo_00.jpg": 52,
	"./promo_01.jpg": 5040,
	"./promo_02.jpg": 5041,
	"./promo_03.jpg": 51,
	"./promo_05.jpg": 5042,
	"./promo_06.jpg": 5043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5039;